import { render, staticRenderFns } from "./EvaluacionDisciplinaOperativaDialogComponent.vue?vue&type=template&id=92bca466"
import script from "./EvaluacionDisciplinaOperativaDialogComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionDisciplinaOperativaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports